import React, { useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { InputAdornment } from "@material-ui/core";
import { CustomTextField } from "containers/gstr2a2bNewEnhancement/Utility/utility";
import downloadWhite from "images/downloadWhite.svg";
import { Button } from "@material-ui/core";
import "../../../../style.css";
import Table from "./Table";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import Sidewise from "./Sidewise";
import { getSideWisedata } from "containers/gstr2a2bNewEnhancement/Reconciliation/action";
import { useDispatch, useSelector } from "react-redux";
import { errorToastMessage } from "utils/errorToast";
import { COMMON_MSGS } from "Constant/Messages";
const NotInPR = (props) => {
  const dispatch = useDispatch();

  const {
    activeTabReco,
    activeTabViewReco,
    activeTabDocView,
    dateRange,
    selection,
    recoSelection,
    selectedYear,
    selectedNotInPR,
    selectedRowNotInPR,
    searchStr
  } = useSelector((store) => store.gstr2a2bNewRecoReducer);

  const { selectedGstin, defaultEntity } = useSelector(
    (store) => store.gstr2a2bNewCommonReducer
  );
  const [open, setOpen] = useState(false);
  const [gstnData, setGstnData] = useState([]);
  const [prData, setPrData] = useState([]);

  // async function handleSidewiseOpen() {
  //   try {
  //     if (
  //       defaultEntity &&
  //       selectedGstin?.length > 0 &&
  //       selection &&
  //       recoSelection &&
  //       selectedYear
  //     ) {
  //       const response = await dispatch(
  //         getSideWisedata(
  //           selectedGstin,
  //           selection,
  //           recoSelection,
  //           selectedYear,
  //           dateRange,
  //           activeTabReco,
  //           activeTabViewReco,
  //           activeTabDocView
  //         )
  //       );
  //       console.log("response::", response);
  //        setGstnData(response.notInGstindata);
  //        setPrData(response.notInPrdata);

  //       setOpen(true);
  //     } else {
  //       errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
  //     }
  //   } catch (error) {
  //     console.log("Error in handleSidewiseOpen:", error);
  //   }
  // }
  async function handleSidewiseOpen() {
  try {
    const isValid =
      defaultEntity &&
      selectedGstin?.length > 0 &&
      selection &&
      recoSelection &&
      selectedYear;

    if (!isValid) {
      errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
      return;
    }

    const response = await dispatch(
      getSideWisedata(
        selectedGstin,
        selection,
        recoSelection,
        selectedYear,
        dateRange,
        activeTabReco,
        activeTabViewReco,
        activeTabDocView
      )
    );

    console.log("Sidewise response:", response);

    if (response) {
      setGstnData(response.notInGstindata || []);
      setPrData(response.notInPrdata || []);
      setOpen(true);
    } else {
      errorToastMessage("No data received from server.");
    }
  } catch (error) {
    console.error("Error in handleSidewiseOpen:", error);
    errorToastMessage("Something went wrong while fetching data.");
  }
}

  async function handleSidewiseClose() {
    setOpen(false);
  }
  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <div style={{ width: "35%", marginTop: "0.3em" }}>
          <CustomTextField
            style={{ backgroundColor: "white" }}
            placeholder="Search"
            className="custom-search-field"
            variant="outlined"
            size="small"
             value={searchStr}
            onChange={props.handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <Button
          onClick={props.handleDownload}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          <img
            src={downloadWhite}
            alt="Download"
            style={{
              width: "30px",
              height: "20px",
              paddingBottom: "3px",
            }}
          />
        </Button>
        <Button
          onClick={props.handleOpen}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
            paddingLeft: "1.5em",
            paddingRight: "1.5em",
          }}
        >
          Filter
        </Button>
        <Button
          onClick={()=>props.handleAcceptPrGstn(selectedNotInPR,'GSTN',selectedRowNotInPR)}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          Accept GSTN
        </Button>

        <Button
          onClick={()=>props.handlePending(selectedNotInPR,'PENDING',selectedRowNotInPR)}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          Pending
        </Button>

        <Button
          onClick={()=>props.handleReject(selectedNotInPR,'REJECT',selectedRowNotInPR)}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          Reject
        </Button>
        <Button
          onClick={handleSidewiseOpen}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          Side wise Match
        </Button>
      </div>
      <Table handlePageClick={props.handlePageClick} handleSubmit={props.handleSubmit}/>
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth="xs"
        open={open}
      >
        <MuiDialogTitle
          disableTypography
          style={{ color: "#4f2d7f", backgroundColor: "white" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div></div>
            <Typography variant="h6">{"Sidewise Match"}</Typography>
            <CloseIcon
              onClick={() => handleSidewiseClose()}
              style={{ cursor: "pointer" }}
            />
          </div>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          <div>
            <Sidewise
              open={open}
              handleSidewiseClose={handleSidewiseClose}
              handleAcceptGSTN={props.handleAcceptGSTN}
              handleAcceptPR={props.handleAcceptPR}
              handleReject={props.handleReject}
              handleReset={props.handleReset}
              gstnData={gstnData}
              prData={prData}
            />
          </div>
        </MuiDialogContent>
      </Dialog>
    </>
  );
};

export default NotInPR;
